<template>
    <tutorial-layout :title="$trans('storefront::image_editor.select_tutorial_title')" @nextPage="nextPage" :last-page="true">
        <p>
            {{ $trans('storefront::image_editor.select_tutorial_description') }}
        </p>

        <div ref="animation-window" class="d-flex align-items-center justify-content-center flex-grow-1 w-100" style="max-width: 70%">
            <div class="position-relative">
                <img :src="$getImg('image-editor/mobile-tutorial/'+image)" class="img-fluid" style="max-width: 200px">
                <div class="position-absolute inset-0 d-flex justify-content-center align-items-center">
                    <finger ref="leftFinger"></finger>
                </div>
            </div>
        </div>
    </tutorial-layout>
</template>


<script>
import anime from 'animejs/lib/anime.es.js';
import TutorialLayout from "./TutorialLayout";
import Finger from "../Finger";
import {animateFingerPress, animateFingerRelease} from "../js/mobileTutorial";

export default {
    components: {Finger, TutorialLayout},
    data() {
        return {
            animationTimeline: null,
            isDestroyed: false,
            image: 'select-example-1.jpg',
        }
    },
    mounted() {
        this.$nextTick(this.playAnimation);
    },
    beforeDestroy() {
        this.isDestroyed = true;

        if (this.animationTimeline) {
            this.animationTimeline.pause();
        }
    },
    methods: {
        pos (value) {
            return (this.$refs['animation-window'].clientWidth) * value;
        },
        resetAnimation() {
            this.animationTimeline.seek(0);
            this.image = 'select-example-1.jpg';
        },
        playAnimation () {
            let app = this;
            this.animationTimeline = anime.timeline({
                easing: 'easeOutQuad',
                complete: () => {
                    app.resetAnimation();

                    if (app.isDestroyed) return;

                    app.playAnimation();
                }
            });

            this.animationTimeline.add({
                duration: 500
            });

            animateFingerPress(this.animationTimeline, this.$refs.leftFinger.$el, 500);

            this.animationTimeline.add({
                targets: app.$refs['animation-window'].querySelector('img'),
                duration: 500,
                complete: () => {
                    app.image = 'select-example-2.jpg';
                }
            });

            this.animationTimeline.add({
                duration: 200
            });

            animateFingerRelease(this.animationTimeline, this.$refs.leftFinger.$el, 2100);

            this.animationTimeline.add({
                duration: 2000
            });
        },
        nextPage() {
            this.$emit('nextPage');
        },
    }
}
</script>
